import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* verifyMerchant({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.store_domains.verify, id: values.id, data: { domain: values.domain } });

    onSuccess && onSuccess();
    yield put(actions.verifyMerchantDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.verifyMerchantFailed,
      handledErrors,
      endpoint: api.store_domains.verify.url
    });
  }
}

export const verifyMerchantSaga = takeEvery(types.VERIFY_MERCHANT_REQUEST, verifyMerchant);